import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { SelfAssessmentT2Filter } from 'src/app/core/models/self-assessmentT2/seld-assessmentT2-filter';
import { SelfAssessmentT2MasterFilter } from 'src/app/core/models/self-assessmentT2/self-assessmentT2-master-filter';
import { GDPRService } from 'src/app/core/services/rulebook';
import { MasterHelper } from 'src/app/core/utilities';

@Component({
  selector: 'app-self-assessment-t2-filter',
  templateUrl: './self-assessment-t2-filter.component.html',
  styleUrls: ['./self-assessment-t2-filter.component.scss']
})
export class SelfAssessmentT2FilterComponent implements OnInit {
  @Output() OnFilterT2 = new EventEmitter<SelfAssessmentT2Filter>();

  @ViewChild('keywordInput') keywordInput!: ElementRef<HTMLInputElement>;
  @ViewChild('autoKeyword') autoKeyword!: MatAutocomplete;

  //Owner
  @ViewChild('oWInput')
  oWInput!: ElementRef<HTMLInputElement>;
  @ViewChild('oWAutocomplete')
  oWAutocomplete!: MatAutocomplete;
  searchOWCntrl: FormControl = new FormControl();
  searchedOwner: FilterViewModel[] = [];

  //Assessment Team
  @ViewChild('aTInput')
  aTInput!: ElementRef<HTMLInputElement>;
  @ViewChild('aTAutocomplete')
  aTAutocomplete!: MatAutocomplete;
  searchATCntrl: FormControl = new FormControl();
  searchedAT: FilterViewModel[] = [];

  //Assessment Status
  @ViewChild('aSInput')
  aSInput!: ElementRef<HTMLInputElement>;
  @ViewChild('aSAutocomplete')
  aSAutocomplete!: MatAutocomplete;
  searchASCntrl: FormControl = new FormControl();
  searchedAS: FilterViewModel[] = [];

  //Compliance Status
  @ViewChild('cSInput')
  cSInput!: ElementRef<HTMLInputElement>;
  @ViewChild('cSAutocomplete')
  cSAutocomplete!: MatAutocomplete;
  searchCSCntrl: FormControl = new FormControl();
  searchedCS: FilterViewModel[] = [];

  //Review Team
  @ViewChild('rTInput')
  rTInput!: ElementRef<HTMLInputElement>;
  @ViewChild('rTAutocomplete')
  rTAutocomplete!: MatAutocomplete;
  searchRTCntrl: FormControl = new FormControl();
  searchedRT: FilterViewModel[] = [];

  //Review Status
  @ViewChild('rSInput')
  rSInput!: ElementRef<HTMLInputElement>;
  @ViewChild('rSAutocomplete')
  rSAutocomplete!: MatAutocomplete;
  searchRSCntrl: FormControl = new FormControl();
  searchedRS: FilterViewModel[] = [];

  //Interpretation
  @ViewChild('iPInput')
  iPInput!: ElementRef<HTMLInputElement>;
  @ViewChild('iPAutocomplete')
  iPAutocomplete!: MatAutocomplete;
  searchIPCntrl: FormControl = new FormControl();
  searchedIP: FilterViewModel[] = [];

  //Data Judgement
  @ViewChild('dJInput')
  dJInput!: ElementRef<HTMLInputElement>;
  @ViewChild('dJAutocomplete')
  dJAutocomplete!: MatAutocomplete;
  searchDJCntrl: FormControl = new FormControl();
  searchedDJ: FilterViewModel[] = [];

  //Compliance Gaps
  @ViewChild('cGInput')
  cGInput!: ElementRef<HTMLInputElement>;
  @ViewChild('cGAutocomplete')
  cGAutocomplete!: MatAutocomplete;
  searchCGCntrl: FormControl = new FormControl();
  searchedCG: FilterViewModel[] = [];

  //Enhancements
  @ViewChild('eNInput')
  eNInput!: ElementRef<HTMLInputElement>;
  @ViewChild('eNAutocomplete')
  eNAutocomplete!: MatAutocomplete;
  searchENCntrl: FormControl = new FormControl();
  searchedEN: FilterViewModel[] = [];

  //Approvals Team
  @ViewChild('apTInput')
  apTInput!: ElementRef<HTMLInputElement>;
  @ViewChild('apTAutocomplete')
  apTAutocomplete!: MatAutocomplete;
  searchAPTCntrl: FormControl = new FormControl();
  searchedAPT: FilterViewModel[] = [];

  //Approvals Status
  @ViewChild('apSInput')
  apSInput!: ElementRef<HTMLInputElement>;
  @ViewChild('apSAutocomplete')
  apSAutocomplete!: MatAutocomplete;
  searchAPSCntrl: FormControl = new FormControl();
  searchedAPS: FilterViewModel[] = [];


  filterT2PersistenceKey = 'selfAssessmentT2Filters';
  selfAssessmentT2Filter: SelfAssessmentT2Filter;
  masterT2Filters: SelfAssessmentT2MasterFilter;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  isPersistFilter = false;
  filteredKeywords: string[];
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  keyCtrl = new FormControl();
  isLoadingFilters = false;
  oldestCreationDate: string = MasterHelper.getDateStr(30);
  // rulebookRuleId = 0;
  rulebookRuleId: number | null = null;

  constructor(private gdprService: GDPRService, private datePipe: DatePipe) {
    this.selfAssessmentT2Filter = new SelfAssessmentT2Filter();
    this.masterT2Filters = new SelfAssessmentT2MasterFilter();
    this.selfAssessmentT2Filter.fromDate = '';
    this.selfAssessmentT2Filter.toDate = '';
    const persistFilter = JSON.parse(
      this.fetchFromBrowser(this.filterT2PersistenceKey) as string
    ) as SelfAssessmentT2Filter;
    if (persistFilter) {
      this.selfAssessmentT2Filter = persistFilter;
      if(this.selfAssessmentT2Filter.rulebookRuleID != ''){
        this.rulebookRuleId = parseInt(this.selfAssessmentT2Filter.rulebookRuleID);
      }
      this.isPersistFilter = true;
    }
    this.filteredKeywords = [];
  }

  ngOnInit(): void { 
    if (!this.isPersistFilter) {
      this.initFilters();
    }
    // this.initFilters();
    this.getMasterFilters();
  }

  initFilters(): void {
    this.selfAssessmentT2Filter = new SelfAssessmentT2Filter();
    this.gdprService.getOldestDateT2().subscribe((res: string) => {
      if (res) {
        // this.selfAssessmentT2Filter.fromDate = res;
        // this.oldestCreationDate = res;

        this.selfAssessmentT2Filter.fromDate = res;
        const parts = this.selfAssessmentT2Filter.fromDate.split("T");
        const datePart = parts[0];
        this.selfAssessmentT2Filter.fromDate = datePart;
        this.oldestCreationDate = res;
      }
    });

    this.selfAssessmentT2Filter.ruleBook = [];
    this.selfAssessmentT2Filter.part = [];
    this.selfAssessmentT2Filter.owner = [];
    this.selfAssessmentT2Filter.regulatoryRuleFullRequirement = [];
    this.selfAssessmentT2Filter.assessmentTeam = [];
    this.selfAssessmentT2Filter.assessmentDetails = [];
    this.selfAssessmentT2Filter.assessmentStatus = [];
    this.selfAssessmentT2Filter.complianceStatus = [];
    this.selfAssessmentT2Filter.reviewerTeam = [];
    this.selfAssessmentT2Filter.reviewDetails = [];
    this.selfAssessmentT2Filter.reviewStatus = [];
    this.selfAssessmentT2Filter.interpretation = [];
    this.selfAssessmentT2Filter.interpretationDetails = [];
    this.selfAssessmentT2Filter.judgement = [];
    // this.selfAssessmentT2Filter.noOfJudgements = 0;
    this.selfAssessmentT2Filter.judgementDetails = [];
    this.selfAssessmentT2Filter.gaps = [];
    this.selfAssessmentT2Filter.gapDetail = [];
    // this.selfAssessmentT2Filter.noOfGaps = 0;
    this.selfAssessmentT2Filter.enhancement = [];
    this.selfAssessmentT2Filter.enhancementDescription = [];
    // this.selfAssessmentT2Filter.noOfEnhancement = 0;
    this.selfAssessmentT2Filter.approvalTeam = [];
    this.selfAssessmentT2Filter.approvalStatus = [];
    this.selfAssessmentT2Filter.approvalComment = [];
    this.selfAssessmentT2Filter.searchQuery = [];
    this.selfAssessmentT2Filter.rulebookRuleID = "";
    this.rulebookRuleId = null;

    this.searchedOwner = this.masterT2Filters.owner;
    this.searchedAT = this.masterT2Filters.assessmentTeam;
    this.searchedAS = this.masterT2Filters.assessmentStatus;
    this.searchedCS = this.masterT2Filters.complianceStatus;
    this.searchedRT = this.masterT2Filters.reviewerTeam;
    this.searchedRS = this.masterT2Filters.reviewStatus;
    this.searchedIP = this.masterT2Filters.interpretation;
    this.searchedDJ = this.masterT2Filters.judgement;
    this.searchedCG = this.masterT2Filters.gaps;
    this.searchedEN = this.masterT2Filters.enhancement;
    this.searchedAPT = this.masterT2Filters.approvalTeam;
    this.searchedAPS = this.masterT2Filters.approvalStatus;
    this.selfAssessmentT2Filter.fromDate = this.datePipe.transform(this.selfAssessmentT2Filter.fromDate, "yyyy-MM-dd")!;
    this.selfAssessmentT2Filter.toDate = this.datePipe.transform(this.selfAssessmentT2Filter.toDate, "yyyy-MM-dd")!;
    
    this.saveOnBrowser(
      this.filterT2PersistenceKey,
      JSON.stringify(this.selfAssessmentT2Filter)
    );
    this.OnFilterT2.emit(this.selfAssessmentT2Filter);
    // this.searchedKey = this.masterFilters.searchQuery;
    // this.saveOnBrowser(
    //   this.filterPersistenceKey,
    //   JSON.stringify(this.selfAssessmentFilter)
    // );
    // this.OnFilter.emit(this.selfAssessmentFilter);
  }
  async resetFilters():Promise<void>{
    this.selfAssessmentT2Filter = new SelfAssessmentT2Filter();
    
    let res:string= await this.gdprService.getOldestDateT2().toPromise();
    if(res){
      this.selfAssessmentT2Filter.fromDate = res;
      const parts = this.selfAssessmentT2Filter.fromDate.split("T");
      const datePart = parts[0];
      this.selfAssessmentT2Filter.fromDate = datePart;
      this.oldestCreationDate = res;
    }
    // this.gdprService.getOldestDateT2().subscribe((res: string) => {
    //   if (res) {
    //     this.selfAssessmentT2Filter.fromDate = res;
    //     const parts = this.selfAssessmentT2Filter.fromDate.split("T");
    //     const datePart = parts[0];
    //     this.selfAssessmentT2Filter.fromDate = datePart;
    //     this.oldestCreationDate = res;
    //   }
    // });
    this.selfAssessmentT2Filter.ruleBook = [];
    this.selfAssessmentT2Filter.part = [];
    this.selfAssessmentT2Filter.owner = [];
    this.selfAssessmentT2Filter.regulatoryRuleFullRequirement = [];
    this.selfAssessmentT2Filter.assessmentTeam = [];
    this.selfAssessmentT2Filter.assessmentDetails = [];
    this.selfAssessmentT2Filter.assessmentStatus = [];
    this.selfAssessmentT2Filter.complianceStatus = [];
    this.selfAssessmentT2Filter.reviewerTeam = [];
    this.selfAssessmentT2Filter.reviewDetails = [];
    this.selfAssessmentT2Filter.reviewStatus = [];
    this.selfAssessmentT2Filter.interpretation = [];
    this.selfAssessmentT2Filter.interpretationDetails = [];
    this.selfAssessmentT2Filter.judgement = [];
    // this.selfAssessmentT2Filter.noOfJudgements = 0;
    this.selfAssessmentT2Filter.judgementDetails = [];
    this.selfAssessmentT2Filter.gaps = [];
    this.selfAssessmentT2Filter.gapDetail = [];
    // this.selfAssessmentT2Filter.noOfGaps = 0;
    this.selfAssessmentT2Filter.enhancement = [];
    this.selfAssessmentT2Filter.enhancementDescription = [];
    // this.selfAssessmentT2Filter.noOfEnhancement = 0;
    this.selfAssessmentT2Filter.approvalTeam = [];
    this.selfAssessmentT2Filter.approvalStatus = [];
    this.selfAssessmentT2Filter.approvalComment = [];
    this.selfAssessmentT2Filter.searchQuery = [];
    this.selfAssessmentT2Filter.rulebookRuleID = "";
    this.rulebookRuleId = null;

    this.searchedOwner = this.masterT2Filters.owner;
    this.searchedAT = this.masterT2Filters.assessmentTeam;
    this.searchedAS = this.masterT2Filters.assessmentStatus;
    this.searchedCS = this.masterT2Filters.complianceStatus;
    this.searchedRT = this.masterT2Filters.reviewerTeam;
    this.searchedRS = this.masterT2Filters.reviewStatus;
    this.searchedIP = this.masterT2Filters.interpretation;
    this.searchedDJ = this.masterT2Filters.judgement;
    this.searchedCG = this.masterT2Filters.gaps;
    this.searchedEN = this.masterT2Filters.enhancement;
    this.searchedAPT = this.masterT2Filters.approvalTeam;
    this.searchedAPS = this.masterT2Filters.approvalStatus;
    this.selfAssessmentT2Filter.fromDate = this.datePipe.transform(this.selfAssessmentT2Filter.fromDate, "yyyy-MM-dd")!;
    this.selfAssessmentT2Filter.toDate = this.datePipe.transform(this.selfAssessmentT2Filter.toDate, "yyyy-MM-dd")!;
    this.selfAssessmentT2Filter.SortKey = 'AssessmentCreationDate';
    this.selfAssessmentT2Filter.IsDesc = true;
    this.saveOnBrowser(
      this.filterT2PersistenceKey,
      JSON.stringify(this.selfAssessmentT2Filter)
    );
    this.OnFilterT2.emit(this.selfAssessmentT2Filter);
  }

  getMasterFilters(): void {
    this.isLoadingFilters = true;
    this.gdprService
      .getSelfAssessmentT2MasterFilters()
      .subscribe((result: SelfAssessmentT2MasterFilter) => {
        this.masterT2Filters = result;
        this.searchedOwner = this.masterT2Filters.owner;
        this.searchedAT = this.masterT2Filters.assessmentTeam;
        this.searchedAS = this.masterT2Filters.assessmentStatus;
        this.searchedCS = this.masterT2Filters.complianceStatus;
        this.searchedRT = this.masterT2Filters.reviewerTeam;
        this.searchedRS = this.masterT2Filters.reviewStatus;
        this.searchedIP = this.masterT2Filters.interpretation;
        this.searchedDJ = this.masterT2Filters.judgement;
        this.searchedCG = this.masterT2Filters.gaps;
        this.searchedEN = this.masterT2Filters.enhancement;
        this.searchedAPT = this.masterT2Filters.approvalTeam;
        this.searchedAPS = this.masterT2Filters.approvalStatus;
        this.isLoadingFilters = false;

        this.searchOWCntrl.valueChanges.subscribe((data: any) => {
          this.searchedOwner = data
            ? this.filterData(data, 'Owner')
            : this.masterT2Filters.owner;
        });

        this.searchATCntrl.valueChanges.subscribe((data: any) => {
          this.searchedAT = data
            ? this.filterData(data, 'AssessmentTeam')
            : this.masterT2Filters.assessmentTeam;
        });
        this.searchASCntrl.valueChanges.subscribe((data: any) => {
          this.searchedAS = data
            ? this.filterData(data, 'AssessmentStatus')
            : this.masterT2Filters.assessmentStatus;
        });
        this.searchCSCntrl.valueChanges.subscribe((data: any) => {
          this.searchedCS = data
            ? this.filterData(data, 'ComplianceStatus')
            : this.masterT2Filters.complianceStatus;
        });
        this.searchRTCntrl.valueChanges.subscribe((data: any) => {
          this.searchedRT = data
            ? this.filterData(data, 'ReviewerTeam')
            : this.masterT2Filters.reviewerTeam;
        });
        this.searchRSCntrl.valueChanges.subscribe((data: any) => {
          this.searchedRS = data
            ? this.filterData(data, 'ReviewStatus')
            : this.masterT2Filters.reviewStatus;
        });
        this.searchIPCntrl.valueChanges.subscribe((data: any) => {
          this.searchedIP = data
            ? this.filterData(data, 'Interpretation')
            : this.masterT2Filters.interpretation;
        });
        this.searchDJCntrl.valueChanges.subscribe((data: any) => {
          this.searchedDJ = data
            ? this.filterData(data, 'Judgement')
            : this.masterT2Filters.judgement;
        });
        this.searchCGCntrl.valueChanges.subscribe((data: any) => {
          this.searchedCG = data
            ? this.filterData(data, 'Gaps')
            : this.masterT2Filters.gaps;
        });
        this.searchENCntrl.valueChanges.subscribe((data: any) => {
          this.searchedEN = data
            ? this.filterData(data, 'Enhancement')
            : this.masterT2Filters.enhancement;
        });
        this.searchAPTCntrl.valueChanges.subscribe((data: any) => {
          this.searchedAPT = data
            ? this.filterData(data, 'ApprovalTeam')
            : this.masterT2Filters.approvalTeam;
        });
        this.searchAPSCntrl.valueChanges.subscribe((data: any) => {
          this.searchedAPS = data
            ? this.filterData(data, 'ApprovalStatus')
            : this.masterT2Filters.approvalStatus;
        });
      });
  }
  //KeyWord Search Event
  add(event: MatChipInputEvent): void {
    if (!this.autoKeyword.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        this.selfAssessmentT2Filter.searchQuery.push(value.trim());
      }

      event.chipInput!.clear();
      this.keyCtrl.setValue(null);
    }
  }
  remove(_searchstr: string): void {
    const index = (this.selfAssessmentT2Filter.searchQuery as string[]).indexOf(
      _searchstr
    );

    if (index >= 0) {
      (this.selfAssessmentT2Filter.searchQuery as string[]).splice(index, 1);
    }
  }
  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.selfAssessmentT2Filter.searchQuery) {
      this.selfAssessmentT2Filter.searchQuery.push(event.option.viewValue);
    } else {
      this.selfAssessmentT2Filter.searchQuery = [];
      this.selfAssessmentT2Filter.searchQuery.push(event.option.viewValue);
    }
    this.keywordInput.nativeElement.value = '';
    this.keyCtrl.setValue(null);
    this.keyCtrl.disable();
    this.keyCtrl.enable();
  }

  // Rule Book events
  addRB(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentT2Filter.ruleBook?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentT2Filter.ruleBook.push(value.trim());
    }
    event.chipInput!.clear();
  }
  removeRB(status: string): void {
    const index = this.selfAssessmentT2Filter.ruleBook.indexOf(status);

    if (index >= 0) {
      this.selfAssessmentT2Filter.ruleBook.splice(index, 1);
    }
  }
  //Part Events
  addPA(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentT2Filter.part?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentT2Filter.part.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removePA(status: string): void {
    const index = this.selfAssessmentT2Filter.part.indexOf(status);

    if (index >= 0) {
      this.selfAssessmentT2Filter.part.splice(index, 1);
    }
  }

  // Owner Events
  addOW(event: MatChipInputEvent): void {
    if (!this.oWAutocomplete.isOpen) {
      const value = event.value;
      if ((value || '').trim()) {
        let sameValueRow = this.selfAssessmentT2Filter.owner.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.selfAssessmentT2Filter.owner as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchOWCntrl.setValue(null);
    }
  }

  selectedOWEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentT2Filter.owner.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentT2Filter.owner) {
        this.selfAssessmentT2Filter.owner.push(event.option.viewValue);
      } else {
        this.selfAssessmentT2Filter.owner = [];
        this.selfAssessmentT2Filter.owner.push(event.option.viewValue);
      }
    }
    this.oWInput.nativeElement.value = '';
    this.searchOWCntrl.setValue(null);
    this.searchOWCntrl.disable();
    this.searchOWCntrl.enable();
  }

  removeOW(status: string): void {
    const index = (this.selfAssessmentT2Filter.owner as string[]).indexOf(
      status
    );
    if (index >= 0) {
      (this.selfAssessmentT2Filter.owner as string[]).splice(index, 1);
    }
  }

  // Rule Regulator Events
  addRR(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentT2Filter.regulatoryRuleFullRequirement?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentT2Filter.regulatoryRuleFullRequirement.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeRR(status: string): void {
    const index = this.selfAssessmentT2Filter.regulatoryRuleFullRequirement.indexOf(status);

    if (index >= 0) {
      this.selfAssessmentT2Filter.regulatoryRuleFullRequirement.splice(index, 1);
    }
  }

  filterData(search: string, filter: string): any {
    switch (filter) {
      case 'Owner':
        return this.searchedOwner.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      case 'AssessmentTeam':
        return this.searchedAT.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      case 'AssessmentStatus':
        return this.searchedAS.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      case 'ComplianceStatus':
        return this.searchedCS.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      case 'ReviewerTeam':
        return this.searchedRT.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      case 'ReviewStatus':
        return this.searchedRS.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      case 'Interpretation':
        return this.searchedIP.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      case 'Judgement':
        return this.searchedDJ.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      case 'Gaps':
        return this.searchedCG.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      case 'Enhancement':
        return this.searchedEN.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      case 'ApprovalTeam':
        return this.searchedAPT.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      case 'ApprovalStatus':
        return this.searchedAPS.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      default:
        return new Array<FilterViewModel>();
        break;
    }
  }

  // Assessment Team Events
  addAT(event: MatChipInputEvent): void {
    if (!this.aTAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentT2Filter.assessmentTeam as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchATCntrl.setValue(null);
    }
  }

  selectedATEvent(event: MatAutocompleteSelectedEvent): void {
    let filterResult = this.selfAssessmentT2Filter.assessmentTeam?.filter((obj) => obj === event.option.viewValue);
    if (filterResult && filterResult.length == 0) {
      if (this.selfAssessmentT2Filter.assessmentTeam) {
        this.selfAssessmentT2Filter.assessmentTeam.push(event.option.viewValue);
      } else {
        this.selfAssessmentT2Filter.assessmentTeam = [];
        this.selfAssessmentT2Filter.assessmentTeam.push(event.option.viewValue);
      }
    }

    this.aTInput.nativeElement.value = '';
    this.searchATCntrl.setValue(null);
    this.searchATCntrl.disable();
    this.searchATCntrl.enable();
  }

  removeAT(status: string): void {
    const index = (
      this.selfAssessmentT2Filter.assessmentTeam as string[]
    ).indexOf(status);

    if (index >= 0) {
      (this.selfAssessmentT2Filter.assessmentTeam as string[]).splice(index, 1);
    }
  }

  // Assessment Details Events
  addAD(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentT2Filter.assessmentDetails?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentT2Filter.assessmentDetails.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeAD(status: string): void {
    const index = this.selfAssessmentT2Filter.assessmentDetails.indexOf(status);

    if (index >= 0) {
      this.selfAssessmentT2Filter.assessmentDetails.splice(index, 1);
    }
  }

  // Assessment Status Events
  addAS(event: MatChipInputEvent): void {
    if (!this.aSAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentT2Filter.assessmentStatus as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchASCntrl.setValue(null);
    }
  }

  selectedASEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentT2Filter.assessmentStatus.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentT2Filter.assessmentStatus) {
        this.selfAssessmentT2Filter.assessmentStatus.push(event.option.viewValue);
      } else {
        this.selfAssessmentT2Filter.assessmentStatus = [];
        this.selfAssessmentT2Filter.assessmentStatus.push(event.option.viewValue);
      }
    }

    this.aSInput.nativeElement.value = '';
    this.searchASCntrl.setValue(null);
    this.searchASCntrl.disable();
    this.searchASCntrl.enable();
  }

  removeAS(status: string): void {
    const index = (
      this.selfAssessmentT2Filter.assessmentStatus as string[]
    ).indexOf(status);

    if (index >= 0) {
      (this.selfAssessmentT2Filter.assessmentStatus as string[]).splice(index, 1);
    }
  }

  // Compliance Status Events
  addCS(event: MatChipInputEvent): void {
    if (!this.cSAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentT2Filter.complianceStatus as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchCSCntrl.setValue(null);
    }
  }

  selectedCSEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentT2Filter.complianceStatus.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentT2Filter.complianceStatus) {
        this.selfAssessmentT2Filter.complianceStatus.push(event.option.viewValue);
      } else {
        this.selfAssessmentT2Filter.complianceStatus = [];
        this.selfAssessmentT2Filter.complianceStatus.push(event.option.viewValue);
      }
    }

    this.cSInput.nativeElement.value = '';
    this.searchCSCntrl.setValue(null);
    this.searchCSCntrl.disable();
    this.searchCSCntrl.enable();
  }

  removeCS(status: string): void {
    const index = (
      this.selfAssessmentT2Filter.complianceStatus as string[]
    ).indexOf(status);

    if (index >= 0) {
      (this.selfAssessmentT2Filter.complianceStatus as string[]).splice(index, 1);
    }
  }

  // Review Team Events
  addRT(event: MatChipInputEvent): void {
    if (!this.rTAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentT2Filter.reviewerTeam as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchRTCntrl.setValue(null);
    }
  }
  selectedRTEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentT2Filter.reviewerTeam.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentT2Filter.reviewerTeam) {
        this.selfAssessmentT2Filter.reviewerTeam.push(event.option.viewValue);
      } else {
        this.selfAssessmentT2Filter.reviewerTeam = [];
        this.selfAssessmentT2Filter.reviewerTeam.push(event.option.viewValue);
      }
    }
    this.rTInput.nativeElement.value = '';
    this.searchRTCntrl.setValue(null);
    this.searchRTCntrl.disable();
    this.searchRTCntrl.enable();
  }
  removeRT(status: string): void {
    const index = (this.selfAssessmentT2Filter.reviewerTeam as string[]).indexOf(
      status
    );

    if (index >= 0) {
      (this.selfAssessmentT2Filter.reviewerTeam as string[]).splice(index, 1);
    }
  }

  // Review Details Events
  addRD(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentT2Filter.reviewDetails?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentT2Filter.reviewDetails.push(value.trim());
    }
    event.chipInput!.clear();
  }
  removeRD(status: string): void {
    const index = this.selfAssessmentT2Filter.reviewDetails.indexOf(status);

    if (index >= 0) {
      this.selfAssessmentT2Filter.reviewDetails.splice(index, 1);
    }
  }

  // Review Status Events
  addRS(event: MatChipInputEvent): void {
    if (!this.rSAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentT2Filter.reviewStatus as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchRSCntrl.setValue(null);
    }
  }
  selectedRSEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentT2Filter.reviewStatus.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentT2Filter.reviewStatus) {
        this.selfAssessmentT2Filter.reviewStatus.push(event.option.viewValue);
      } else {
        this.selfAssessmentT2Filter.reviewStatus = [];
        this.selfAssessmentT2Filter.reviewStatus.push(event.option.viewValue);
      }
    }
    this.rSInput.nativeElement.value = '';
    this.searchRSCntrl.setValue(null);
    this.searchRSCntrl.disable();
    this.searchRSCntrl.enable();
  }
  removeRS(status: string): void {
    const index = (this.selfAssessmentT2Filter.reviewStatus as string[]).indexOf(
      status
    );
    if (index >= 0) {
      (this.selfAssessmentT2Filter.reviewStatus as string[]).splice(index, 1);
    }
  }

  // Interpretation Events
  addIP(event: MatChipInputEvent): void {
    if (!this.iPAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentT2Filter.interpretation as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchIPCntrl.setValue(null);
    }
  }
  selectedIPEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentT2Filter.interpretation.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentT2Filter.interpretation) {
        this.selfAssessmentT2Filter.interpretation.push(event.option.viewValue);
      } else {
        this.selfAssessmentT2Filter.interpretation = [];
        this.selfAssessmentT2Filter.interpretation.push(event.option.viewValue);
      }
    }
    this.iPInput.nativeElement.value = '';
    this.searchIPCntrl.setValue(null);
    this.searchIPCntrl.disable();
    this.searchIPCntrl.enable();
  }
  removeIP(status: string): void {
    const index = (this.selfAssessmentT2Filter.interpretation as string[]).indexOf(
      status
    );
    if (index >= 0) {
      (this.selfAssessmentT2Filter.interpretation as string[]).splice(index, 1);
    }
  }

  // Interpretation Details Events
  addID(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentT2Filter.interpretationDetails?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentT2Filter.interpretationDetails.push(value.trim());
    }
    event.chipInput!.clear();
  }
  removeID(status: string): void {
    const index = this.selfAssessmentT2Filter.interpretationDetails.indexOf(status);

    if (index >= 0) {
      this.selfAssessmentT2Filter.interpretationDetails.splice(index, 1);
    }
  }

  // Data Judgement Events
  addDJ(event: MatChipInputEvent): void {
    if (!this.dJAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentT2Filter.judgement as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchDJCntrl.setValue(null);
    }
  }
  selectedDJEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentT2Filter.judgement.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentT2Filter.judgement) {
        this.selfAssessmentT2Filter.judgement.push(event.option.viewValue);
      } else {
        this.selfAssessmentT2Filter.judgement = [];
        this.selfAssessmentT2Filter.judgement.push(event.option.viewValue);
      }
    }
    this.dJInput.nativeElement.value = '';
    this.searchDJCntrl.setValue(null);
    this.searchDJCntrl.disable();
    this.searchDJCntrl.enable();
  }
  removeDJ(status: string): void {
    const index = (this.selfAssessmentT2Filter.judgement as string[]).indexOf(
      status
    );
    if (index >= 0) {
      (this.selfAssessmentT2Filter.judgement as string[]).splice(index, 1);
    }
  }

  // Data Judgement Details Events
  addJD(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentT2Filter.judgementDetails?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentT2Filter.judgementDetails.push(value.trim());
    }
    event.chipInput!.clear();
  }
  removeJD(status: string): void {
    const index = this.selfAssessmentT2Filter.judgementDetails.indexOf(status);

    if (index >= 0) {
      this.selfAssessmentT2Filter.judgementDetails.splice(index, 1);
    }
  }

  // Compliance Gaps Events
  addCG(event: MatChipInputEvent): void {
    if (!this.cGAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentT2Filter.gaps as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchCGCntrl.setValue(null);
    }
  }
  selectedCGEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentT2Filter.gaps.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentT2Filter.gaps) {
        this.selfAssessmentT2Filter.gaps.push(event.option.viewValue);
      } else {
        this.selfAssessmentT2Filter.gaps = [];
        this.selfAssessmentT2Filter.gaps.push(event.option.viewValue);
      }
    }
    this.cGInput.nativeElement.value = '';
    this.searchCGCntrl.setValue(null);
    this.searchCGCntrl.disable();
    this.searchCGCntrl.enable();
  }
  removeCG(status: string): void {
    const index = (this.selfAssessmentT2Filter.gaps as string[]).indexOf(
      status
    );
    if (index >= 0) {
      (this.selfAssessmentT2Filter.gaps as string[]).splice(index, 1);
    }
  }

  // Compliance Gap Details Events
  addGD(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentT2Filter.gapDetail?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentT2Filter.gapDetail.push(value.trim());
    }
    event.chipInput!.clear();
  }
  removeGD(status: string): void {
    const index = this.selfAssessmentT2Filter.gapDetail.indexOf(status);

    if (index >= 0) {
      this.selfAssessmentT2Filter.gapDetail.splice(index, 1);
    }
  }

  // Enhancement Events
  addEN(event: MatChipInputEvent): void {
    if (!this.eNAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentT2Filter.enhancement as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchENCntrl.setValue(null);
    }
  }
  selectedENEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentT2Filter.enhancement.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentT2Filter.enhancement) {
        this.selfAssessmentT2Filter.enhancement.push(event.option.viewValue);
      } else {
        this.selfAssessmentT2Filter.enhancement = [];
        this.selfAssessmentT2Filter.enhancement.push(event.option.viewValue);
      }
    }
    this.eNInput.nativeElement.value = '';
    this.searchENCntrl.setValue(null);
    this.searchENCntrl.disable();
    this.searchENCntrl.enable();
  }
  removeEN(status: string): void {
    const index = (this.selfAssessmentT2Filter.enhancement as string[]).indexOf(
      status
    );
    if (index >= 0) {
      (this.selfAssessmentT2Filter.enhancement as string[]).splice(index, 1);
    }
  }

  // Enhancement Details Events
  addED(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentT2Filter.enhancementDescription?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentT2Filter.enhancementDescription.push(value.trim());
    }
    event.chipInput!.clear();
  }
  removeED(status: string): void {
    const index = this.selfAssessmentT2Filter.enhancementDescription.indexOf(status);

    if (index >= 0) {
      this.selfAssessmentT2Filter.enhancementDescription.splice(index, 1);
    }
  }

  // Approval Team Events
  addAPT(event: MatChipInputEvent): void {
    if (!this.apTAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentT2Filter.approvalTeam as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchAPTCntrl.setValue(null);
    }
  }
  selectedAPTEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentT2Filter.approvalTeam.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentT2Filter.approvalTeam) {
        this.selfAssessmentT2Filter.approvalTeam.push(event.option.viewValue);
      } else {
        this.selfAssessmentT2Filter.approvalTeam = [];
        this.selfAssessmentT2Filter.approvalTeam.push(event.option.viewValue);
      }
    }
    this.apTInput.nativeElement.value = '';
    this.searchAPTCntrl.setValue(null);
    this.searchAPTCntrl.disable();
    this.searchAPTCntrl.enable();
  }
  removeAPT(status: string): void {
    const index = (this.selfAssessmentT2Filter.approvalTeam as string[]).indexOf(
      status
    );
    if (index >= 0) {
      (this.selfAssessmentT2Filter.approvalTeam as string[]).splice(index, 1);
    }
  }

  // Approval Status Events
  addAPS(event: MatChipInputEvent): void {
    if (!this.apSAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentT2Filter.approvalStatus as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchAPSCntrl.setValue(null);
    }
  }
  selectedAPSEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentT2Filter.approvalStatus.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentT2Filter.approvalStatus) {
        this.selfAssessmentT2Filter.approvalStatus.push(event.option.viewValue);
      } else {
        this.selfAssessmentT2Filter.approvalStatus = [];
        this.selfAssessmentT2Filter.approvalStatus.push(event.option.viewValue);
      }
    }
    this.apSInput.nativeElement.value = '';
    this.searchAPSCntrl.setValue(null);
    this.searchAPSCntrl.disable();
    this.searchAPSCntrl.enable();
  }
  removeAPS(status: string): void {
    const index = (this.selfAssessmentT2Filter.approvalStatus as string[]).indexOf(
      status
    );
    if (index >= 0) {
      (this.selfAssessmentT2Filter.approvalStatus as string[]).splice(index, 1);
    }
  }

  // Approval Comment Events
  addAPC(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentT2Filter.approvalComment?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentT2Filter.approvalComment.push(value.trim());
    }
    event.chipInput!.clear();
  }
  removeAPC(status: string): void {
    const index = this.selfAssessmentT2Filter.approvalComment.indexOf(status);

    if (index >= 0) {
      this.selfAssessmentT2Filter.approvalComment.splice(index, 1);
    }
  }

  TriggerAction(): void {
    this.selfAssessmentT2Filter.fromDate = this.datePipe.transform(this.selfAssessmentT2Filter.fromDate, "yyyy-MM-dd")!;
    this.selfAssessmentT2Filter.toDate = this.datePipe.transform(this.selfAssessmentT2Filter.toDate, "yyyy-MM-dd")!;
    this.selfAssessmentT2Filter.rulebookRuleID = this.rulebookRuleId == null? "" : this.rulebookRuleId.toString();
    this.selfAssessmentT2Filter = MasterHelper.parseSelfAssessmentT2Filters(
      this.selfAssessmentT2Filter
    ) as SelfAssessmentT2Filter;
    this.saveOnBrowser(
      this.filterT2PersistenceKey,
      JSON.stringify(this.selfAssessmentT2Filter)
    );
    this.OnFilterT2.emit(this.selfAssessmentT2Filter);
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }
}
